import type { ComboStats } from '@/services/combo.service';

// Regression: GitHub issue #286 — "Combos 'Avg Savings' KPI is computed from the
// current page only, so the average savings % shifts as you paginate".
//
// The "Avg Savings" card must reflect EVERY combo (matching the current filters)
// and stay constant across pages. It now comes from the tenant-wide
// `/combos/stats` aggregate, never from the current 20-row page slice. This maps
// the raw server mean into the one-decimal percentage the card shows; before the
// stats load (null) we show 0 rather than a page-derived guess.
export function deriveAvgSavings(stats: ComboStats | null): number {
  if (!stats) return 0;
  return Math.round(stats.avg_savings * 10) / 10;
}
